var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"map",staticClass:"monitor-map"}),_c('div',{staticClass:"caption grey--text mt-1"},[_vm._v("\n        ตำแหน่งล่าสุดเท่าที่โทรศัพท์คนขับส่งมาได้ ไม่ใช่ตำแหน่งปัจจุบันแบบต่อเนื่อง\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }